
import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { consumptionData } from '@/data/gas-analytics-data';

const GasConsumptionAreaChart = () => {
  return (
    <AnimatedCard 
      animation="fade-up"
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Gas Consumption Trends (m³)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={consumptionData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`${value} m³`, 'Consumption']}
                contentStyle={{ 
                  borderRadius: '8px', 
                  border: 'none', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                }}
              />
              <Area 
                type="monotone" 
                dataKey="consumption" 
                stroke="#F97316" 
                fill="#F97316" 
                fillOpacity={0.2}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasConsumptionAreaChart;
